import { sendEventToAnalytics } from '../../helpers/common-helpers';
import PopupClass from '../common/PopupClass';

export default class DemoVideoClass {
    constructor() {
        this.popupClassInit = new PopupClass();
        this.demoVideoId = 'demo-video';

        this.init();
    }

    init() {
        this.openDemoPopupByParameter();
    }

    openDemoPopupByParameter() {
        const url = new URL(window.location.href);
        const mode = url.searchParams.get('demo');
        const demoPopup = document.getElementById(this.demoVideoId);

        if (demoPopup && mode) {
            const iframe = demoPopup.querySelector('iframe');

            iframe.src = `/demo/${mode}/index.html`;
            this.popupClassInit.open(this.demoVideoId);

            this.sendEventsToAnalytics(mode);
        }
    }

    sendEventsToAnalytics(mode) {
        window.addEventListener('message', (event) => {
            const normalizedMode = mode.replace(/[-_\s]+/g, '');
            const demoStatusMap = {
                'onDemoStart': 'start',
                'onDemoComplete': 'finish'
            };

            if (demoStatusMap[event.data]) {
                const eventName = `${demoStatusMap[event.data]}_demo_${normalizedMode}`;
                sendEventToAnalytics(eventName);
            }

            if (demoStatusMap[event.data] === 'finish') {
                sendEventToAnalytics('open_book_meeting');
            }
        });
    }
}